import React, { useEffect, useState } from "react";
import axios from "../../../../../axios";
import { IP } from "./../../../../../internalServer"
// css comes in published_hw.css

const HwCompletedStudentList = (props) => {
  const [studentdata, setStudentData] = useState([]);
  useEffect(() => {
    axios
      .get(
        `/api/v1/homework/studentHomework/getByHomeworkId/${props.homework_id}?status=pending&isOnlyList=true`
      )
      .then((res) => {
        res && setStudentData(res.data.data);
      });
  }, []);
  // 
  return (
    <>
      <div className=" mt-2 p-0 student_list_box ">
        <div className=" student_list_header_colour"></div>
        <div className="px-2 mt-2 d-flex align-items-center justify-content-between student_list_header_box">
          <span>Homework Assigned to</span>
          {/* <img src="/images/cross.svg" alt="" style={{ cursor: "pointer" }} /> */}
        </div>
        <div className="mx-2 mt-1 completed_student_count">
          Total {studentdata.length} Students
        </div>
        <div className="p-2 mt-1 mx-2 completed_name_list_box ">
          <div className="mb-2 gap-2">
            {/* <img src="/images/status circle1.svg" alt="" /> */}
            {studentdata.map((obj) => {
              return (
                <div className="completed_s_name_list mb-2 gap-2 d-flex align-items-center ">
                  {<img
                    src={
                      obj?.student_id
                        ? IP + obj?.student_id?.profile_picture.replace(/^\./, "")
                        : obj?.student_id?.gender === "M"
                          ? obj?.student_id?.avatar_profile ? '/images/Boys/' + obj?.student_id?.avatar_profile + '.webp'
                            : "/images/Student_boy_pic.png"
                          : obj?.student_id?.gender === "F"
                            ? obj?.student_id?.avatar_profile ? '/images/Girls/' + obj?.student_id?.avatar_profile + '.webp'
                              : "/images/Student_girl_pic.png"
                            : "/images/default image.png"
                    }
                    alt="icon"
                    style={{ width: "20px", height: "20px", borderRadius: "50%" }}
                    className=""
                    key={obj?.student_id?.avatar_profile}
                    onError={(e) => {
                      if (obj?.student_id?.gender === "M") {
                        e.target.src = obj?.student_id?.avatar_profile ? '/images/Boys/' + obj?.student_id?.avatar_profile + '.webp' : "/images/Student_boy_pic.png"
                      } else if (obj?.student_id?.gender === "F") {
                        e.target.src = obj?.student_id?.avatar_profile ? '/images/Girls/' + obj?.student_id?.avatar_profile + '.webp' : "/images/Student_girl_pic.png"
                      } else {
                        e.target.src = "/images/default image.png"
                      }
                    }}
                  />}
                  <span className="acti_completed_s_name">
                    {obj?.student_id?.name} | {"Roll No: " + obj?.student_id?.roll_number}
                  </span>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default HwCompletedStudentList;
